const PaymentSection = () => (
  <section
    id="payment"
    className="py-20 md:py-24 px-4 md:px-8 relative overflow-hidden"
    style={{ background: '#161616' }}
  >
    {/* Background image with parallax feel */}
    <div
      className="absolute inset-0 opacity-10"
      style={{
        backgroundImage: `url('https://readdy.ai/api/search-image?query=venmo%20payment%20app%20phone%20screen%20dark%20background%20financial%20transaction%20digital%20payment%20close%20up%20moody%20lighting%20industrial%20texture%20charcoal%20tones%20minimal%20clean&width=1920&height=600&seq=payment-bg-001&orientation=landscape')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    />
    <div className="absolute inset-0 bg-gradient-to-r from-[#161616] via-transparent to-[#161616]" />

    <div className="relative z-10 max-w-4xl mx-auto">
      <div className="text-center mb-12">
        <p className="text-[#D4FF00] font-mono text-xs tracking-[0.4em] uppercase mb-3">How It Works</p>
        <h2
          className="text-4xl md:text-5xl text-white uppercase tracking-widest mb-4"
          style={{ fontFamily: '"Black Ops One", "Impact", sans-serif' }}
        >
          PAYMENT INSTRUCTIONS
        </h2>
        <div className="h-px max-w-xs mx-auto bg-gradient-to-r from-transparent via-[#CE1126] to-transparent" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {[
          {
            step: '01',
            icon: 'ri-file-list-3-line',
            title: 'FILL THE LOGBOOK',
            desc: 'Complete the order form above with your details, product selection, and delivery preference.',
          },
          {
            step: '02',
            icon: 'ri-send-plane-line',
            title: 'DISPATCH ORDER',
            desc: 'Hit the DISPATCH ORDER button. You\'ll receive a confirmation with your total amount due.',
          },
          {
            step: '03',
            icon: 'ri-bank-card-line',
            title: 'VENMO PAYMENT',
            desc: 'After submitting your order, you\'ll receive Venmo payment details. Send the amount due and your order is confirmed.',
          },
        ].map((item) => (
          <div
            key={item.step}
            className="border border-[#2a2a2a] p-6 relative"
            style={{ background: '#1e1e1e' }}
          >
            <div
              className="absolute top-4 right-4 font-black text-5xl opacity-10"
              style={{ fontFamily: '"Courier New", monospace', color: '#CE1126' }}
            >
              {item.step}
            </div>
            <div className="w-12 h-12 flex items-center justify-center mb-4" style={{ background: '#CE1126' }}>
              <i className={`${item.icon} text-xl text-white`} />
            </div>
            <h3
              className="text-white text-lg uppercase tracking-widest mb-3"
              style={{ fontFamily: '"Black Ops One", "Impact", sans-serif' }}
            >
              {item.title}
            </h3>
            <p className="text-[#888] font-mono text-sm leading-relaxed">{item.desc}</p>
          </div>
        ))}
      </div>


    </div>
  </section>
);

export default PaymentSection;
